import axios from 'axios'
const state = {
  notices: [],
  question: []
}

const getters = {
  getNotices (state) {
    return state.notices
  },
  getQuestions (state) {
    return state.question
  }
}

const mutations = {
  setNotices (state, payload) {
    state.notices = payload
  },
  setQuestion (state, payload) {
    state.question = payload
  }
}

const actions = {
  apiNotices (context, payload) {
    axios.post('/api/notice/getNotice', payload)
      .then((response) => {
        // console.log(response.data)
        if (response.data.length > 0) {
          context.commit('setNotices', response.data)
        } else {
          alert('검색 값이 존재하지 않습니다.')
        }
      })
      .catch((error) => {
        alert(error.response.data.message)
      })
  },
  apiQuestions (context, payload) {
    axios.post('/api/notice/getQuestions', payload)
      .then((response) => {
        // console.log(response.data)
        if (response.data.length > 0) {
          context.commit('setQuestion', response.data)
        } else {
          alert('자주하는 질문이 존재하지 않습니다.')
        }
      })
      .catch((error) => {
        alert(error.response.data.message)
      })
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/notice.js